import { Observable } from 'rxjs';

export interface UserAuthData {
  mem_id: number;
  mem_user_name: string;
  mem_email: string;
  wmt_id: number;
  campus_branch_code: number;
}

export interface LoginResponse {
  code: number,
  message: Array<UserAuthData>
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class Auth {
  abstract user(username: string, password: string): Observable<LoginResponse>;

  abstract logout(): Observable<ApiResponse>;

  abstract getSession(): Observable<ApiResponse>;
}
